import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-lead',
  templateUrl: './lead.component.html',
  styleUrls: ['./lead.component.css']
})
export class LeadComponent implements OnInit {
  leadForm: FormGroup;
  searchString: any = '';

  loading = false;
  toggle = true;
  infoFlag = false;
  error: any;

  channelPartners:any;
  subBrokers:any;

  project:any;
  projectID:any;

  leads = [] as any;
  editId = null;
  currentUser:any;

  sales_officers = [] as any;
  isloading = true;
  isCP = false;

  aso:any;

  constructor(
    private _formBuilder: FormBuilder,
    private SharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.currentUser = this.SharedService.getUser();
    this.formRestValue();
    this.toggle = true;
    this.isloading = true;
    this.leads = [];
    this.sales_officers = [];

    this.SharedService.getLeads().subscribe((data:any)=>{
      data.data.forEach(element => {
        if(element.project.id === this.project._id){
          this.leads.push(element)
        }
      });
      this.isloading = false;
      // console.log(this.leads)
    })

    this.SharedService.getDelaers().subscribe((data:any)=>{
      this.channelPartners = data.data;
    })

    this.SharedService.users().subscribe((response) => {
      response.data.forEach(user => {
        if(user.project === this.project._id && user.role === 'sales'){
          this.sales_officers.push(user)
        }
      });
    },
      (error) => {
        console.log(error);
      })
  }

  getSubBrokers(cpid:any){
    this.aso = 'auto assign';
    this.leadForm.patchValue({sale_person: 'auto'});
    this.channelPartners.forEach(cp => {
      if(cp._id === cpid){
        this.aso = cp.sales_officer.name;
        this.leadForm.patchValue({sale_person: cp.sales_officer._id});
      }
    });
  }

  back(){
    this.toggle = !this.toggle;
    this.infoFlag = false;
    this.editId = null;
    this.leadForm.reset();
    this.formRestValue();
  }

  edit(lead:any){
    this.leadForm.patchValue(lead);
    this.leadForm.patchValue({project: lead.project.id});
    if(lead.channel_partner){
      this.isCP = true;
      this.leadForm.patchValue({channel_partner: lead.channel_partner._id});
      this.aso = lead.sale_person.name;
    }else{
      this.leadForm.patchValue({sale_person: lead.sale_person._id});
    }
    this.toggle = false;
    this.editId = lead.id;
  }

  info(lead:any){
    // console.log(lead);
    this.leadForm.patchValue(lead);
    this.leadForm.patchValue({project: lead.project.id});
    if(lead.channel_partner){
      this.isCP = true;
      this.leadForm.patchValue({channel_partner: lead.channel_partner._id});
      this.aso = lead.sale_person.name;
    }else{
      this.leadForm.patchValue({sale_person: lead.sale_person._id});
    }

    this.leadForm.controls['name'].disable();
    this.leadForm.controls['contact_1'].disable();
    this.leadForm.controls['contact_2'].disable();
    this.leadForm.controls['email'].disable();
    this.leadForm.controls['job'].disable();
    this.leadForm.controls['address'].disable();
    this.leadForm.controls['source'].disable();
    this.leadForm.controls['channel_partner'].disable();
    this.leadForm.controls['sale_person'].disable();
    this.leadForm.controls['sub_broker'].disable();
    this.leadForm.controls['notes'].disable();
    this.leadForm.controls['project'].disable();
    this.infoFlag = true;
    this.toggle = false;
  }

  onSubmit(): any {
    if (this.leadForm.invalid) {
      this.Toast.fire({
        title: 'Error!',
        text: 'Please fill all required fields',
        icon: 'error'
      })
      return
    } else if(this.editId == null) {
      this.loading = true;
      console.log(this.leadForm.value)
      this.SharedService.createLead(this.leadForm.value).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'Lead has been created',
          icon: 'success'
        })
        this.loading = false;
        window.scrollTo(0, 0);
        this.ngOnInit();

      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error'
          })
          this.loading = false;
        })
    }else if(this.editId != null) {
      this.loading = true;
      console.log(this.leadForm.value)
      this.SharedService.updateLead(this.leadForm.value,this.editId).subscribe((response) => {
        console.log(response);
        this.Toast.fire({
          title: 'Done!',
          text: 'Lead has been updated',
          icon: 'success'
        })
        this.loading = false;
        window.scrollTo(0, 0);
        this.ngOnInit();

      },
        (error) => {
          console.log(error);
          this.Toast.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error'
          })
          this.loading = false;
        })
    }
  }

  delete(user: any): any {

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete lead ' + user.name,
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        if(user.status.toLowerCase() === user.property?.status.toLowerCase()){
          alert("Cannot Delete as Customer hold's a property")
        }else{
          this.SharedService.deleteLead(user._id).subscribe(response => {
            console.log(response)
            this.Toast.fire({
              title: 'Deleted!',
              text: 'The user has been deleted',
              icon: 'success'
            })
            this.ngOnInit();
          },
          (error)=>{
            console.log(error);
            this.Toast.fire({
              title: 'Error!',
              text: error.error,
              icon: 'error',
            });
          })
        }

      }
    })

}

  formRestValue(){
    // this.SharedService.getProjects().subscribe((data:any)=>{
    //   this.project = data.data;
    //   // console.log(this.project)
    // })
    this.project = this.SharedService.getProject()

    this.leadForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      contact_1: ['', [Validators.required]],
      contact_2: [''],
      email: [''],
      job: [''],
      address: ['', [Validators.required]],
      source: ['walk-in',[Validators.required]],
      channel_partner: [],
      sale_person: ['auto'],
      sub_broker: [],
      notes: [''],
      project: [this.project._id,[Validators.required]]
    });
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

}
